import { throwInline } from './utils/throwErrorInline'

const FirebaseEnvironmentConfig: Record<string, {
  apiKey: string
  authDomain: string
  databaseURL?: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
}> = {
  production: {
    apiKey: 'AIzaSyCD-GfLubpP_XeahyN6sg4iO-atuv3SHlo',
    authDomain: 'clipsal-iconic-configurator.firebaseapp.com',
    databaseURL: 'https://clipsal-iconic-configurator.firebaseio.com',
    projectId: 'clipsal-iconic-configurator',
    storageBucket: 'clipsal-iconic-configurator.appspot.com',
    messagingSenderId: '850693816005',
    appId: '1:850693816005:web:b24573d08950e0484e3aac'
  },
  uat: {
    apiKey: 'AIzaSyAvrjrXJoJiSlC4-MCC_kGUDSj_UeNsHPg',
    authDomain: 'se-iconic-builder-uat.firebaseapp.com',
    projectId: 'se-iconic-builder-uat',
    storageBucket: 'se-iconic-builder-uat.appspot.com',
    messagingSenderId: '379679171806',
    appId: '1:379679171806:web:5ac62dcb09e5b24e0ece4f'
  }
}

export const FirebaseEnvironmentName = process.env.REACT_APP_FIREBASE_PROJECT || throwInline('firebase project not set')

const FirebaseConfig = FirebaseEnvironmentConfig[FirebaseEnvironmentName]
  ?? throwInline(`firebase project config not found for "${FirebaseEnvironmentName}"`)

export default FirebaseConfig
